import React from "react";
import { Form } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { EmailTitleWrapperFont } from "../styles";
import moment from "moment";
import { DOBWrap } from "./styles";
import { MarginSpecific } from "./styles";
import Calendar from '../../../../../CommonComponents/Calendar/Calendar';


function  disabledDate(current) {
  // Can not select days before today and today
  return current && current > moment().endOf('day');
}
const DatePickerComponent = props => {
  const { getFieldDecorator } = props.form;
  return (
    <div>
      <FormItem
        colon={false}
        label={
          <MarginSpecific paddingTop="2px">
            <EmailTitleWrapperFont>{props.title}</EmailTitleWrapperFont>
          </MarginSpecific>
        }
      >
        {getFieldDecorator(`dob${props.id}`, {
          rules: [
            {
              type: "string"
            }
          ]
        })(
          <DOBWrap height="22px">
            <Calendar
              id={props.id}
              ariaLabel={props.ariaLabel}
              name={props.name}
              onBlur={props.handleBlur}
              placeHolder={props.placeholder}
              format="MM/DD/YYYY"
              disabledDate={disabledDate}
              onChange={ e => props.handleInputChange ? props.handleInputChange(e): ''}
              allowClear={false}
              value={
                props.value ? moment(props.value, "MM/DD/YYYY") : undefined
              }
              allowClear={false}
            />
          </DOBWrap>
        )}
      </FormItem>
    </div>
  );
};

const WrappedDOBComponent = Form.create({ name: "dob" })(DatePickerComponent);

export default WrappedDOBComponent;
